import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/core/core_page/404.vue';
import Home from './views/Home.vue';
import plusView from './views/plusView/microPlusView.vue';
import otpPlusView from './views/otpPlusView/microPlusView.vue';
const originalPush = Router.prototype.push;
Router.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
export const routeConfig = [
    {
        path: '/secondaryLogon',
        name: 'secondaryLogon',
        meta: { title: '二次验证' },
        component: () => import('./views/secondaryLogon/index.vue')
    },
    {
        path: '/',
        component: Home,
        redirect: '/homePage',
        hidden: false,
        fdId: '1',
        fdFrontLink: '/sn-login',
        name: '常用示例',
        children: [
            {
                path: '/',
                redirect: '/homePage'
            },
            // 系统管理
            {
                path: '/domain',
                name: 'domain',
                meta: { title: 'panelPoint.route.domain' },
                component: () => import('./views/systemManagement/domainTable/Index')
            },
            {
                path: '/node',
                name: 'node',
                meta: { title: 'panelPoint.route.node' },
                component: () => import('./views/systemManagement/nodeTable/Index')
            },
            {
                path: '/step',
                name: 'step',
                meta: { title: 'panelPoint.route.step' },
                component: () => import('./views/systemManagement/stepTable/Index')
            },
            {
                path: '/scene',
                name: 'scene',
                meta: { title: 'panelPoint.route.scene' },
                component: () => import('./views/systemManagement/sceneTable/Index')
            },
            {
                path: '/es',
                name: 'es',
                meta: { title: 'panelPoint.route.es' },
                component: () => import('./views/systemManagement/esConfig/Index')
            },
            {
                path: '/tenant',
                name: 'tenant',
                meta: { title: 'panelPoint.route.tenant' },
                component: () => import('./views/systemManagement/tenantConfig/Index')
            },
            {
                path: '/quota',
                name: 'quota',
                meta: { title: 'panelPoint.route.quota' },
                component: () => import('./views/systemManagement/quotaConfig/Index')
            },
            {
                path: '/oss',
                name: 'oss',
                meta: { title: 'panelPoint.route.oss' },
                component: () => import('./views/systemManagement/ossConfig/Index')
            },
            {
                path: '/companyPrefix',
                name: 'companyPrefix',
                meta: { title: 'panelPoint.route.companyPrefix' },
                component: () => import('./views/systemManagement/companyPrefix/Index.vue')
            },
            {
                path: '/newPrefix',
                name: 'newPrefix',
                meta: { title: 'panelPoint.route.newPrefix' },
                component: () => import('./views/systemManagement/companyPrefix/newPrefix.vue')
            },
            {
                path: '/recentNews',
                name: 'recentNews',
                meta: { title: 'panelPoint.route.recentNews' },
                component: () => import('./views/systemManagement/recentNews/Index.vue')
            },
            {
                path: '/dataDictionary',
                name: 'dataDictionary',
                meta: { title: 'panelPoint.route.dataDictionary' },
                component: () => import('./views/systemManagement/dataDictionary/Index.vue')
            },
            {
                path: '/guideManage',
                name: 'guideManage',
                meta: { title: 'panelPoint.route.guideManage' },
                component: () => import('./views/systemManagement/guideManage/Index.vue')
            },
            {
                path: '/guidePreview',
                name: 'guidePreview',
                meta: { title: 'panelPoint.route.guidePreview' },
                component: () => import('./views/systemManagement/guideManage/guidePreview.vue')
            },
            {
                path: '/callIdentifier',
                name: 'callIdentifier',
                meta: { title: 'panelPoint.route.callIdentifier' },
                component: () => import('./views/systemManagement/callIdentifier/Index.vue')
            },
            {
                path: '/tenantRelations',
                name: 'tenantRelations',
                meta: { title: 'panelPoint.route.tenantRelations' },
                component: () => import('./views/systemManagement/tenantRelations/Index.vue')
            },
            // 标识管理
            {
                path: '/changeNews',
                name: 'changeNews',
                meta: { title: 'panelPoint.route.changeNews' },
                component: () => import('./views/systemManagement/recentNews/changeNews.vue')
            },
            {
                path: '/notice',
                name: 'notice',
                meta: { title: 'panelPoint.route.notice' },
                component: () => import('./views/systemManagement/noticeConfig/index.vue')
            },
            {
                path: '/changeNotice',
                name: 'changeNotice',
                meta: { title: 'panelPoint.route.changeNotice' },
                component: () => import('./views/systemManagement/noticeConfig/changeNotice.vue')
            },
            {
                path: '/detailsNotice',
                name: 'detailsNotice',
                meta: { title: 'panelPoint.route.detailsNotice' },
                component: () => import('./views/systemManagement/noticeConfig/detailsNotice.vue')
            },
            // {
            //     path: '/signDesign',
            //     name: 'signDesign',
            //     meta: { title: 'panelPoint.route.signDesign' },
            //     component: () => import('./views/systemManagement/signDesign/Index.vue')
            // },
            // 标识管理
            {
                path: '/IdentityInquire',
                name: 'IdentityInquire',
                meta: { title: 'panelPoint.route.IdentityInquire' },
                component: () => import('./views/IdentityManagement/IdentityInquire/Index')
            },
            {
                path: '/IdentityInquireDetail',
                name: 'IdentityInquireDetail',
                meta: { title: 'panelPoint.route.IdentityInquireDetail' },
                component: () => import('./views/IdentityManagement/IdentityInquire/detail/Index')
            },
            {
                path: '/identificationPrint',
                name: 'identificationPrint',
                meta: { title: 'panelPoint.route.identificationPrint' },
                component: () => import('./views/IdentityManagement/identificationPrint/Index')
            },
            // 报表管理
            {
                path: '/analysisReport',
                name: 'analysisReport',
                meta: { title: 'panelPoint.route.analysisReport' },
                component: () => import('./views/reportManagement/analysisReport/Index')
            },
            {
                path: '/corporateIdentify',
                name: 'corporateIdentify',
                meta: { title: 'panelPoint.route.corporateIdentify' },
                component: () => import('./views/reportManagement/corporateIdentify/Index')
            },
            {
                path: '/IdentifyRanking',
                name: 'IdentifyRanking',
                meta: { title: 'panelPoint.route.IdentifyRanking' },
                component: () => import('./views/reportManagement/IdentifyRanking/Index')
            },
            // 日志管理
            {
                path: '/abnormalLog',
                name: 'abnormalLog',
                meta: { title: 'panelPoint.route.abnormalLog' },
                component: () => import('./views/logManagement/abnormalLog/Index')
            },
            {
                path: '/enterLog',
                name: 'enterLog',
                meta: { title: 'panelPoint.route.enterLog' },
                component: () => import('./views/logManagement/enterLog/Index')
            },
            {
                path: '/permissionMaintain',
                name: 'permissionMaintain',
                meta: { title: 'panelPoint.route.permissionMaintain' },
                component: () => import('./views/logManagement/permissionMaintain/Index')
            },
            {
                path: '/productMaintenance',
                name: 'productMaintenance',
                meta: { title: 'panelPoint.route.productMaintenance' },
                component: () => import('./views/logManagement/productMaintenance/Index')
            },
            {
                path: '/IdentityRegistrationLog',
                name: 'IdentityRegistrationLog',
                meta: { title: 'panelPoint.route.IdentityRegistrationLog' },
                component: () => import('./views/logManagement/IdentityRegistrationLog/Index')
            },
            {
                path: '/IdentityResolutionLog',
                name: 'IdentityResolutionLog',
                meta: { title: 'panelPoint.route.IdentityResolutionLog' },
                component: () => import('./views/logManagement/IdentityResolutionLog/Index')
            },
            {
                path: '/operationLog',
                name: 'operationLog',
                meta: { title: 'panelPoint.route.operationLog' },
                component: () => import('./views/logManagement/operationLog/Index')
            },
            {
                path: '/apiLog',
                name: 'apiLog',
                meta: { title: 'panelPoint.route.apiLog' },
                component: () => import('./views/logManagement/apiLog/Index')
            },
            // 二级节点首页
            {
                path: '/homePage',
                name: 'homePage',
                meta: { title: 'panelPoint.route.homePage' },
                component: () => import('./views/afterLoginIndex/Index.vue')
            },
            // 二级节点-产品
            {
                path: '/product',
                name: 'product',
                meta: { title: 'panelPoint.route.product' },
                component: () => import('./views/product/productTemplate/Index.vue')
            },
            {
                path: '/publicproperty',
                name: 'publicproperty',
                meta: { title: 'panelPoint.route.publicproperty' },
                component: () => import('./views/product/publicProperty/Index.vue')
            },
            {
                path: '/productcontrol',
                name: 'productcontrol',
                meta: { title: 'panelPoint.route.productcontrol' },
                component: () => import('./views/product/productControl/Index.vue')
            },
            {
                path: '/productProcess',
                name: 'productProcess',
                meta: { title: 'panelPoint.route.productProcess' },
                component: () => import('./views/product/productProcess/Index.vue')
            },
            {
                path: '/producttype',
                name: 'producttype',
                meta: { title: 'panelPoint.route.producttype' },
                component: () => import('./views/product/productType/Index.vue')
            },
            // LBCS
            {
                path: '/processSearch',
                name: 'processSearch',
                meta: { title: 'panelPoint.route.processSearch' },
                component: () => import('./views/lcbsManagement/processSearch/Index.vue')
            },
            {
                path: '/processSearchNew',
                name: 'processSearchNew',
                meta: { title: 'panelPoint.route.processSearch' },
                component: () => import('./views/lcbsManagement/processSearchNew/Index.vue')
            },
            {
                path: '/historyProcessSearch',
                name: 'historyProcessSearch',
                meta: { title: 'panelPoint.route.historyProcessSearch' },
                component: () => import('./views/lcbsManagement/historyProcessSearch/Index.vue')
            },
            {
                path: '/barcodeMerge',
                name: 'barcodeMerge',
                meta: { title: 'panelPoint.route.barcodeMerge' },
                component: () => import('./views/lcbsManagement/barcodeMerge/Index.vue')
            },
            {
                path: '/barcodeArchive',
                name: 'barcodeArchive',
                meta: { title: 'panelPoint.route.barcodeArchive' },
                component: () => import('./views/lcbsManagement/barcodeArchive/index.vue')
            },
            {
                path: '/barcodeProcess',
                name: 'barcodeProcess',
                meta: { title: 'panelPoint.route.processSearch' },
                component: () => import('./views/lcbsManagement/barcodeProcess/index.vue')
            },
            {
                path: '/scanBarCodeCenter',
                name: 'scanBarCodeCenter',
                meta: { title: 'panelPoint.route.scanBarCodeCenter' },
                component: () => import('./views/lcbsManagement/scanBarCodeCenter/Index.vue')
            },
            {
                path: '/processSearchOverseas',
                name: 'processSearchOverseas',
                meta: { title: 'panelPoint.route.processSearchOverseas' },
                component: () => import('./views/lcbsManagement/processSearchOverseas/Index.vue')
            },
            {
                path: '/filesSearch',
                name: 'filesSearch',
                meta: { title: 'panelPoint.route.filesSearch' },
                component: () => import('./views/lcbsManagement/filesSearch/Index.vue')
            },
            {
                path: '/boxControl',
                name: 'boxControl',
                meta: { title: 'panelPoint.route.boxControl' },
                component: () => import('./views/lcbsManagement/BoxControl/Index.vue')
            },
            {
                path: '/scanCodeControll',
                name: 'scanCodeControll',
                meta: { title: 'panelPoint.route.scanCodeControll' },
                component: () => import('./views/lcbsManagement/scanCodeControll/Index.vue')
            },
            {
                path: '/codeAnalysis',
                name: 'codeAnalysis',
                meta: { title: 'panelPoint.route.codeAnalysis' },
                component: () => import('./views/lcbsManagement/codeAnalysis/Index.vue')
            },
            {
                path: '/checkImport',
                name: 'checkImport',
                meta: { title: 'panelPoint.route.checkImport' },
                component: () => import('./views/lcbsManagement/checkImport/Index.vue')
            },
            {
                path: '/checkSearch',
                name: 'checkSearch',
                meta: { title: 'panelPoint.route.checkSearch' },
                component: () => import('./views/lcbsManagement/checkSearch/Index.vue')
            },
            {
                path: '/barCodeRuleGroup',
                name: 'barCodeRuleGroup',
                meta: { title: 'panelPoint.route.barCodeRuleGroup' },
                component: () => import('./views/Commodity/BarCodeRuleGroup/Index.vue')
            },
            {
                path: '/barCodeRule',
                name: 'barCodeRule',
                meta: { title: 'panelPoint.route.barCodeRule' },
                component: () => import('./views/Commodity/BarCodeRule/Index.vue')
            },
            {
                path: '/sellInData',
                name: 'sellInData',
                meta: { title: 'panelPoint.route.sellInData' },
                component: () => import('./views/lcbsManagement/sellInData/Index.vue')
            },
            {
                path: '/plusView/*',
                name: 'plusView',
                component: plusView,
                meta: {
                    title: 'SNP plus页面'
                }
            },
            {
                path: '/otpPlusView/*',
                name: 'otpPlusView',
                component: otpPlusView,
                meta: {
                    title: 'SNP otpPlus页面'
                }
            },
            {
                path: '/404',
                name: 'gwms.route.notFound',
                component: NotFound,
                meta: {
                    title: 'notFound'
                }
            },
            {
                path: '*',
                redirect: {
                    path: '/homePage'
                }
            }
        ]
    }];

export default new Router({
    // mode: 'history',
    base: window.__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL,
    routes: routeConfig
});
